import type { SpaceContact } from 'app/typings/core/common/contacts/contacts';
import type { Space } from 'app/typings/hotels/Space/Space';
import type { SpaceType } from 'app/typings/hotels/SpaceType/SpaceType';
import { getSpaceTypeDisplayName } from 'app/utils/hotels';

export type { SpaceContact };

export const SPACES_CONTACTS_FIELD = 'spacesContacts';

export const DEFAULT_SPACE_CONTACT: SpaceContact = {};

export type SpaceOption = { value: number; label: string };

const getSpaceLabel = (space: Space, spaceTypes: SpaceType[]): string => {
  const typeName = getSpaceTypeDisplayName(
    spaceTypes.find((type) => type.id === space.spaceTypeId)?.name
  );

  return space.name ? `${typeName} - ${space.name}` : typeName;
};

export const buildSpaceOptions = (
  spaces: Space[],
  spaceTypes: SpaceType[]
): SpaceOption[] =>
  spaces
    .filter((space) => {
      if (space.isDeleted) {
        return false;
      }

      const typeName = spaceTypes.find(
        (type) => type.id === space.spaceTypeId
      )?.name;

      return typeName !== 'Room';
    })
    .map((space) => ({
      value: space.id,
      label: getSpaceLabel(space, spaceTypes),
    }));

const normalizeEmail = (email?: string) => (email ?? '').trim().toLowerCase();

export const isDuplicateSpaceEmail = (
  contacts: SpaceContact[] | undefined,
  index: number
): boolean => {
  const current = contacts?.[index];

  if (current?.spaceId === undefined || normalizeEmail(current.email) === '') {
    return false;
  }

  return (contacts ?? []).some(
    (contact, otherIndex) =>
      otherIndex < index &&
      contact.spaceId === current.spaceId &&
      normalizeEmail(contact.email) === normalizeEmail(current.email)
  );
};
